import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import store from 'store'
import { profilePush } from 'actions/index'
import addEditRecord from 'add_edit_modals'

import { PermissibleButton } from 'components/Permissible'
import { UPDATE, PERSON } from 'permissions'

import { Section, Row, RowIcon, EditLink } from 'components/BusinessCard/components/StyledComponents'
import { H6, P, Link, Tooltip } from '@PipelineDeals/shared-react-components'

import { useBusinessCard } from 'components/BusinessCard/context'

const PrimaryContact = () => {
  const { t } = useTranslation()
  const { cardMeta: { showOnlyFields, showEditLink, showTooltips }, callbacks: { onClose }, resource } = useBusinessCard()

  if (!showOnlyFields.includes('primary_contact')) return null

  const primaryContactId = useMemo(() => resource.primary_contact_id || resource.primary_contact?.id, [JSON.stringify(resource)])
  const primaryContactName = useMemo(() => resource.primary_contact?.full_name || `${resource.primary_contact?.first_name || ''} ${resource.primary_contact?.last_name || ''}`, [JSON.stringify(resource)])

  if (!primaryContactId || !primaryContactName) return null

  const openPrimaryContactEditModal = e => {
    e.stopPropagation()
    if (onClose) onClose(false)
    addEditRecord({ resourceType: 'person', resourceId: primaryContactId })
  }

  const handlePrimaryContactClick = event => {
    store.dispatch(profilePush({ event, type: 'Person', id: primaryContactId }))
    if (onClose) onClose(false)
  }

  const renderEditLink = () => (
    <EditLink
      content={<RowIcon className="fas fa-pencil-alt" />}
      data-cypress="bc-edit-primary-contact"
      onClick={openPrimaryContactEditModal}
    />
  )

  return (
    <Section data-cypress="business-card-primary-contact-name">
      <H6>
        {t('businessCard.labels.primaryContact')}
      </H6>
      <Row>
        <Link
          href={`/people/${primaryContactId}`}
          onClick={handlePrimaryContactClick}
          withTextDecoration={false}
        >
          <P>{primaryContactName}</P>
        </Link>

        {showEditLink && (
          <PermissibleButton
            action={UPDATE}
            cypress="bc-edit-primaryContact"
            policy={PERSON}
            user={window.User}
          >
            {showTooltips ? (
              <Tooltip
                content={t('common.buttons.edit')}
                effect="solid"
              >
                {renderEditLink()}
              </Tooltip>
            ) : (
              renderEditLink()
            )}
          </PermissibleButton>
        )}
      </Row>
    </Section>
  )
}

export default PrimaryContact
